<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    hasMiddleAuthors?: boolean
  }>(),
  {
    hasMiddleAuthors: false
  }
)

const authorsWrapperClasses = computed(() => {
  return {
    flex: true,
    'gap-y-1.5': props.hasMiddleAuthors,
    'md:flex-row md:items-center': true,
    'flex-col': props.hasMiddleAuthors,
    'items-center': !props.hasMiddleAuthors
  }
})

</script>

<template>
  <div :class="authorsWrapperClasses">
    <slot />
  </div>
</template>
